import EditorsManager from './src/manager.js';
import MultiEditor from './src/multi-editor';
import Editor from './src/editor';

export default { EditorsManager };